<template>
    <v-dialog
    v-model="show"
    persistent
    width="1200">
   
    <v-card >
        <v-toolbar class="mid-font" color="secondary" dense dark >
            <span class="va-underline"> {{account.id}} - {{account.fullname}} </span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="pa-0 def-font">
               <v-toolbar dense  class="mb-4">
              <span class="va-underline">Current Balance: <strong>{{$money(account.balance)}}</strong> </span>
            <v-spacer/>
               <span style="width: 200px; margin-top: 24px;"> 
                     <v-menu
                        v-model="from_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field 
                                label="From Date"
                                 :value="from_date"
                                 filled
                                 readonly
                                dense
                                outlined
                                append-icon="mdi-calendar"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable @input="from_menu=false" />
                    </v-menu>
               </span>
                <span style="width: 200px; margin-top: 24px;" class="ml-2"> 
                     <v-menu
                        v-model="to_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field 
                                label="To Date"
                                 :value="to_date"
                                 readonly
                                 filled
                                dense
                                outlined
                                append-icon="mdi-calendar"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker v-model="to_date" no-title scrollable @input="to_menu=false, getTrans()" />
                    </v-menu>
               </span>
               <v-icon right color="primary" @click="dlToCsv()">mdi-download</v-icon>
        </v-toolbar>
              <table class="va-table def-font pa-2 mb-4" id="account-trans-table">
                <tr>
                    <th>Date Time</th>
                    <th>Type</th>
                    <th>Description</th>
                    <!-- <th>Transact By</th> -->
                    <th class="text-right">AMOUNT</th>
                </tr>
                 <tr v-for="(item,index) in ITEMS" :key="index" >
                    <td class="border_bot">{{$moment(item.transdt).format("MMM DD, YYYY")}} </td>
                    <td class="border_bot" :class="STATUS_COLOR(item.type)">{{item.type}}</td>
                    <td class="border_bot">{{item.description}}</td>
                    <!-- <td class="text-right border_bot">{{$money(item.payout)}}</td> -->
                     <td class="text-right border_bot">{{$money(item.amount)}}</td>
                </tr>
               
            </table>
          </v-card-text>
          <v-card-actions>
              <small class="text-info">Last update: {{account.balance_update | moment("MMM DD, YYYY hh:mm:ss a")}}</small>
              <v-spacer/>
               <!-- <v-btn small color="warning">ROLLBACK LOAD</v-btn> -->
              <v-btn small color="accent" @click="cashform = true">CASH OUT</v-btn>
             <v-btn small color="success" @click="loadform = true">ADD LOAD</v-btn>
          </v-card-actions>
          <va-load-form :show="loadform" :account="account" @DialogEvent="LfEvent"/>
           <va-cash-out :show="cashform" :account="account" @DialogEvent="CfEvent"/>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: false
      },
      user: {
          type: Object,
          default: ()=>{return {}}
      } 
  },
   data () {
      return {
          loadform: false,
          cashform: false,
          from_menu: false,
          to_menu: false,
          account:{},
          to_date:'',
          from_date:'',
          textval: '',
          items:[],
          valid: true,
           nameRules: [
            v => !!v || '*Required'
        ],
      }
    },
  watch: {
      show(v) {
          if(v) {
               this.account = this.user
                var current_date = this.$moment()
            this.from_date= current_date.subtract(7, "days").format("YYYY-MM-DD")
              this.to_date = this.$moment().format("YYYY-MM-DD")
               this.getTrans()
              
          }
      }
  },
  computed:{
      ITEMS() {
          return this.$store.state.account_transactions
      }
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', {action:action})
    },
    CfEvent(e) {
        this.cashform = false
        if(e != "close") {
            this.cashOut(e)
        }
    },
    LfEvent(e){
        this.loadform = false
        if(e != "close") {
            this.addLoad(e)
        }
    },
    getTrans(){
         this.GET_ACCOUNT_TRANSACTIONS({account: this.account.id, from_date: this.from_date, to_date: this.to_date})
    },
     userDetails(){
          this.$http.post("user/details",{id: this.account.id}).then(response => {
              if(response.data.status) {
                 this.account = response.data.account
              } 
          }).catch(e => {
            console.log(e.data)
          })
    },
     addLoad(load){
          this.$http.post("wallet/load",load).then(response => {
              if(response.data.status) {
                  this.VA_ALERT('success', response.data.message)
                  this.GET_ACCOUNT_TRANSACTIONS({account: this.account.id, from_date: this.from_date, to_date: this.to_date})
                  this.userDetails()
              } else {
                  this.VA_ALERT('error', response.data.message)
              }
          }).catch(e => {
            console.log(e.data)
          })
    },
     cashOut(param){
          this.$http.post("wallet/cashout",param).then(response => {
              if(response.data.status) {
                  this.VA_ALERT('success', response.data.message)
                  this.GET_ACCOUNT_TRANSACTIONS({account: this.account.id, from_date: this.from_date, to_date: this.to_date})
                   this.userDetails()
              } else {
                  this.VA_ALERT('error', response.data.message)
              }
          }).catch(e => {
            console.log(e.data)
          })
    },
    dlToCsv() {
         this.DownloadToCsv ("account-trans-table", this.from_date+"-"+this.to_date)
    }
  }
}
</script>
